import { render, staticRenderFns } from "./PersonalProfileDataView.vue?vue&type=template&id=6ba5b61d&scoped=true&"
import script from "./PersonalProfileDataView.vue?vue&type=script&lang=js&"
export * from "./PersonalProfileDataView.vue?vue&type=script&lang=js&"
import style0 from "./PersonalProfileDataView.vue?vue&type=style&index=0&id=6ba5b61d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba5b61d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCardText,VFlex,VIcon,VLayout,VSpacer,VSubheader,VTextField,VToolbar,VToolbarTitle})
